import React from 'react';
import CustomCollapsible from '../generalPurpose/CustomCollapsible';
import {Category} from '../../../models/IPOCToolWebPortal';
import POCToolContent from './POCToolSinglePageContent/POCToolContent';
import POCToolTopic from './POCToolTopic';

type Props = {
  category: Category;
  isOpen: boolean;
  toolName?: string;
};

export default function POCToolCategory(props: Props) {
  const {category, isOpen, toolName} = props;
  return (
    <CustomCollapsible
      key={category.id}
      title={category.name}
      containerStyle={styles.categoryContainer}
      iconStyle={styles.iconStyle}
      fontStyle={styles.fontStyle}
      toolName={toolName}
      isOpen={isOpen}>
      {[...category.content, ...category.topics]
        .sort((a, b) => a.order - b.order)
        .map(item => {
          if (item.type) {
            return <POCToolContent key={item.id} content={item} />;
          } else {
            return <POCToolTopic key={item.id} topic={item} isOpen={isOpen} />;
          }
        })}
    </CustomCollapsible>
  );
}

const styles = {
  childrenCollapsbleStyle: {
    paddingHorizontal: 16,
  },
  categoryContainer: {
    marginBottom: 8,
  },
  categoryFontStyle: {
    fontWeight: '700',
  },
  iconStyle: {
    marginRight: 20,
    marginTop: 7,
  },
  fontStyle: {
    fontSize: 18,
    fontWeight: 'bold',
    fontolor: '#000000',
  },
};
